export const Pill = ({ cls, children, testid, className = "" }) => (
  <span data-testid={testid} className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-[11px] font-bold whitespace-nowrap ${cls} ${className}`}>
    {children}
  </span>
);

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6 sm:mb-8 fade-up">
    <div>
      <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#24474A]" data-testid="page-title">{title}</h1>
      {subtitle && <p className="mt-2 text-sm sm:text-base text-slate-600">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
  </div>
);

export const Empty = ({ children, testid }) => (
  <div data-testid={testid} className="rounded-2xl border border-dashed border-slate-300 bg-white/60 px-6 py-10 text-center text-sm text-slate-500">
    {children}
  </div>
);
